import React from "react";

export default function Kbd({ children }: { children: React.ReactNode }) {
  return (
    <kbd className="rounded border border-gray-400 bg-gray-100 px-1 py-0.5 text-xs font-semibold text-gray-800 dark:border-gray-500 dark:bg-gray-600 dark:text-gray-100">
      {children}
    </kbd>
  );
}
